import { ModalErrorRepository } from '@/core/domain/modal-error/repositories/modal-error.repository';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { ModalErrorData } from './entities/modal-error-data.entity';
import * as actions from './store/modal-error.actions';

@Injectable({
    providedIn: 'root',
})
export class ModalErrorImplRepository extends ModalErrorRepository {
    constructor(private readonly store: Store) {
        super();
    }

    override setErrorToModal(payload: ModalErrorData) {
        const data = {
            isOpen: true,
            error: payload.error,
            description: payload.description,
            redirectSSO: payload.redirectSSO,
        };

        this.store.dispatch(actions.openModalError({ data }));
        return of();
    }

    override closeErrorModal() {
        this.store.dispatch(actions.closeModalError());
        return of();
    }
}
